 
import FalconCardHeader from '@/components/common/FalconCardHeader';
import HelpTooltip from '@/app/common/components/HelpTooltip';
import { Card } from 'react-bootstrap';
import { changeBgColor } from '@/utils/pre-load/changeBgColor';
import { useAppContext } from '@/Main';
import type { ReactNode } from 'react';

type CardStackedBarChartLoadingProps = {
  title?: ReactNode;
  tooltip?: ReactNode;
};

const CardStackedBarChartLoading = ({
  title,
  tooltip
}: CardStackedBarChartLoadingProps) => {
  const {
    config: { theme }
  } = useAppContext();
  return (
    <Card>
      <FalconCardHeader
        title={
          <div>
            {title}
            <HelpTooltip html={tooltip} />
          </div>
        }
        titleTag="h6"
        className="py-2"
        light
      />
      <Card.Body className="px-0">
        <div style={{ margin: '0px 80px 18px 80px', direction: 'ltr' }}>
          <div className="mt-1 text_chart_loading d-block"></div>
          <div
            className="mt-1 text_chart_loading d-block"
            style={{ width: '95%' }}
          ></div>
          <div
            className="mt-1 text_chart_loading d-block"
            style={{ width: '90%' }}
          ></div>
          <div
            className="mt-1 text_chart_loading d-block"
            style={{ width: '85%' }}
          ></div>
          <div
            className="mt-1 text_chart_loading d-block"
            style={{ width: '75%' }}
          ></div>
          <div
            className="mt-1 text_chart_loading d-block"
            style={{ width: '65%' }}
          ></div>
          <div
            className="mt-1 text_chart_loading d-block"
            style={{ width: '60%' }}
          ></div>
          <div
            className="mt-1 text_chart_loading d-block"
            style={{ width: '55%' }}
          ></div>
          <div
            className="mt-1 text_chart_loading d-block"
            style={{ width: '50%' }}
          ></div>
          <div
            className="mt-1 text_chart_loading d-block"
            style={{ width: '45%' }}
          ></div>
          <div
            className="mt-1 text_chart_loading d-block"
            style={{ width: '40%' }}
          ></div>
          <div
            className="mt-1 text_chart_loading d-block"
            style={{ width: '35%' }}
          ></div>
          <div
            className="mt-1 text_chart_loading d-block"
            style={{ width: '25%' }}
          ></div>
          <div
            className="mt-1 text_chart_loading d-block"
            style={{ width: '25%' }}
          ></div>
          <div
            className="mt-1 text_chart_loading d-block"
            style={{ width: '25%' }}
          ></div>
          <div
            className="mt-1 text_chart_loading d-block"
            style={{ width: '25%' }}
          ></div>
        </div>
      </Card.Body>
      <Card.Footer className="bg-body-tertiary fs--2">
        <div className="text_chart_loading"></div>
      </Card.Footer>
      <style>
        {`
            .text_chart_loading{
              background:${changeBgColor(theme)};
              background-size: 200% 100%;
              background-position: 100% 0;
            }
        `}
      </style>
    </Card>
  );
};

export default CardStackedBarChartLoading;
